<template>
    <div class="vertical-wrapper">
        <h1>Demo Zugänge</h1>

        <div ref="demo-access-list"></div>

    </div>
</template>
<script>
import jexcelStyle from "jexcel/dist/jexcel.css"; // eslint-disable-line no-unused-vars
import jexcel from "jexcel"; // eslint-disable-line no-unused-vars

export default {
    name: 'demo-access-view',
    beforeRouteEnter (to, from, next) { 
        next(vm => { 
            vm.$socket.emit('get-demo-access', {token: vm.token})
            next();
        }) 
    },
    computed:{
        token(){
            return this.$store.getters.token
        }
    },
    sockets:{
        'set-demo-access':function(table){
            console.log(table);
            this.spreadsheet.setData(table)
        }
    },
    data(){
        return{
            options: {
                 data:[[ '', '', '', '',  ]],
                 columns:[
                     
                    { title:'Aktiv', width:50 },
                    { title:'Firma', width:180 },
                    { title:'Name', width:120 },
                    { title:'Nachname', width:120 },

                    { title:'E-mail', width:150 },
                    { title:'Telefon', width:150 },


                    { title:'Letzte Anmeldung', width:150 },
                    { title:'Angemeldungen', width:120 },
                    

                ] 
            }
        }
    },
     mounted(){

        this.spreadsheet = jexcel(this.$refs['demo-access-list'], this.options);
     
        Object.assign(this, this.spreadsheet);
    }
}
</script>